import escapeHtml from "lodash/escape";

import { markdownToHtml } from "src/components/markdown-editor/markdown-to-html";

/** A doc's markdown as the editor's HTML, or as plain text when it doesn't parse. */
export function renderDocHtml(markdown: string): string {
  try {
    return markdownToHtml(markdown);
  } catch (error) {
    console.warn("Doc fell back to plain text", error);
    return `<p>${escapeHtml(markdown)}</p>`;
  }
}
